import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccVenture } from '../acc-ventures-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<AccVenture> {

	return {
		rowName: { singular: 'Venture', plural: 'Ventures' },
		getRowKey: row => '' + row.accVentureId,
		stateKey: 'accelerator-ventures-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
